import React, { FC, ReactNode, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { toast } from "react-toastify";
import UserLoginsTab from "../../../containers/user-logins-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { showError } from "../../../services/utilities/ServiceError";
import { useSelector } from "react-redux";
import { Filter } from "../../../models/Filter";
import { getListOfSiteIdsFromFilter, shouldUpdateCategory } from "../../../utilities/tabUtils";
import { useTabCount } from "../../../hooks/useCategoryTab";

const UserLogins: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();

    useEffect(() => {
        buildCategoriesData();
    }, []);

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            setCategories([{
                displayName: translate.byKey(TranslationKeys.logins),
                heading: translate.byKey(TranslationKeys.logins),
                value: "",
                id: 0,
                count: 0
            }]);

            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }
    }

    const onFilterChange = (filters: Filter[]) => {
        const siteIds = getListOfSiteIdsFromFilter(filters);
        updateTabCount(siteIds)
    };

    const { updateTabCount } = useTabCount({
        tableName: "UserLogin",
        pathToSite: "site",
        categories,
        setCategories,
        customFilters: { id: ">= 50" } // All user below 50 are system users and should not be counted
    });

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <UserLoginsTab
                    setBusy={setBusy}
                    categories={categories}
                    setCategories={setCategories}
                    onFilterChange={onFilterChange} />
            ];
            setTabContent(newTabContent);
        }
    }, [categories]);

    return (
        <>
            <ActivityFrame busy={busy} className="flex flex-grow overflow-y-hidden">
                <div className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            { value: '/access-control/operators', displayName: translate.byKey(TranslationKeys.operators), disableClick: true },
                            { value: "/access-control/operators/logins", displayName: translate.byKey(TranslationKeys.logins) }]}
                        onClick={(item) => history.push(item.value)}>
                    </Breadcrumb>
                    <Tabs
                        className="bg-white"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}>
                        <div className="w-full flex flex-col">
                            {tabContent[selected]}
                        </div>
                        <div className="flex flex-row justify-end button-cluster">
                            <Restricted to={`add.logins.element`}>
                                <Link to={{ pathname: "/access-control/operators/login/" }}>
                                    <button className="flex rounded-lg bg-lime text-white p-2 shadow-lg" id='loginAdddButton'>
                                        <img src={plusIcon} className="px-2 w-8 py-1" alt="" />
                                        <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                    </button>
                                </Link>
                            </Restricted>
                        </div>
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default UserLogins;
